/**
 * 水平布局
 * @class BI.HorizontalLayout
 * @extends BI.Layout
 */
BI.HorizontalLayout = BI.Layout;
BI.shortcut("bi.horizontal", BI.HorizontalLayout);
